/**
 * Active-brand resolver.
 *
 * POP3D is multi-tenant: the brand shown depends on the URL path
 * (/luma, /kinetic, /form, or / for the agency). This module reads the
 * current path once at load and re-exports the matching brand bundle so
 * every `import { brand, products, moodTints } from './products.js'`
 * across the templates keeps working unchanged.
 *
 * To edit a specific brand, edit src/brands/<slug>.js — not this file.
 */
import { resolveBrandSlug } from './brands/registry.js';

const { bundle } = resolveBrandSlug();

export const brand = bundle.brand;
export const products = bundle.products;
export const moodTints = bundle.moodTints;
